module.exports = __webpack_public_path__ + "img/wx_jljt.6015ff1d.jpg";